<p *ngIf="!tenderData.orderNumber"><em>Loading Data...</em></p>

<div *ngIf="tenderData.orderNumber">
    <h3>{{tenderData.carrierName}} - Order #{{tenderData.orderNumber}}-{{tenderData.legNumber}}</h3>

    <p>Please enter all pertitent information</p>
</div>

<div class="row" *ngIf="tenderData.orderNumber && !printVisible">
    <div class="col-lg-3" style="margin: 5px;">
        <div *ngIf="tenderData.orderNumber">
            <p *ngIf="false">
                <label style="display: block;"><strong>Depart From Location:</strong></label>
                <city-dropdown [parentForm]="carrierTenderFormGroup" [ctrlName]="'cityControl'" [placeholder]="'Enter a City'" [isRequired]="true"
                               [defaultCity]="defaultCity" [isCityStateZip]="true" [isDisabled]="true"
                               (citySelected)="pickupCitySet($event,false)" (cityBlurred)="leavePickup()"></city-dropdown>
            </p>

            <p *ngIf="false">
                <label style="display: block;"><strong>Depart From Location Time:</strong></label>
                <kendo-datepicker [disabled]="true" [(ngModel)]="stopData.pickupStopDate" (focusout)="leaveDatePicker()" [max]="maxPickupDate" [ngModelOptions]="{standalone: true}"></kendo-datepicker>
                <kendo-timepicker [disabled]="true" [(ngModel)]="stopData.pickupStopDate" (focusout)="leaveDatePicker()" [format]="'HH:mm'" [ngModelOptions]="{standalone: true}"></kendo-timepicker>
                <span *ngIf="!isPickupStopDateValid" class="font-weight-bold text-danger"><i class="fas fa-times-circle"></i></span>
            </p>
            <p class="text-danger" *ngIf="false&&formValidator.pickupDate">
                <label style="color: red"><strong>Depart Time is past first Pickup</strong></label>
            </p>
            <p *ngIf="travelEstimate.miles > 0" style="margin-bottom: 10px;">
                <label><strong>Miles:</strong></label> {{travelEstimate.miles}}
            </p>
            <p *ngIf="breaks>0">
                <label style="color: red"><strong>Required Breaks: </strong> {{carrierBreaks}} (hours: {{carrierBreakHours}})</label>
            </p>

            <div class="row p-2">
                <div class="col-sm-3 font-weight-bold text-end">
                    Driver 1 Name
                </div>
                <div class="col-sm-7">
                    <select name="driverID" [(ngModel)]="tenderData.driverOneId" class="form-select" (change)="driverChange($event, 1)" [disabled]="authService.authenticated">
                        <option value=""></option>
                        <option *ngFor="let driver of drivers" value="{{driver.contactID}}">{{driver.contactName}}</option>
                    </select>
                </div>
                <div class="col-sm-1" *ngIf="!authService.authenticated">
                    <button (click)="addContact('Driver1')" class="btn btn-sml btn-primary" title="Add Driver"><i class="fas fa-plus"></i></button>
                </div>
                <div class="col-sm-1" *ngIf="!authService.authenticated">
                    <button (click)="editContact('Driver1')" class="btn btn-sml btn-success" title="Edit Driver" *ngIf="tenderData.driverOneId>0"><i class="fas fa-pencil-alt"></i></button>
                </div>
            </div>
            <div class="row p-2" *ngIf="isAddDriver1">
                <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                    <contact-quick-add [tableID]="tenderData.carrierId" [contactTitleID]="3" [contactType]="'Carrier'" [countryCode]="countryCode" (onRefreshContact)="refreshContacts($event, 'Driver1')"></contact-quick-add>
                </div>
            </div>
            <div class="row p-2" *ngIf="isEditDriver1">
                <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                    <contact-quick-edit [contactID]="tenderData.driverOneId" (onRefreshContact)="refreshContacts($event, 'Driver1')"></contact-quick-edit>
                </div>
            </div>
            <div class="row p-2">
                <div class="col-sm-3 font-weight-bold text-end">
                    Driver 1 Cell
                </div>
                <div class="col-sm-9">
                    <!--<kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="selectedDriver.cell"
                                         [ngClass]="(macropointLocationProviderDevice=='Mobile'&&(selectedDriver.cell==''||selectedDriver.cell==null)) ? 'border border-danger' : ''"
                                         [disabled]="true" [required]="macropointLocationProviderDevice=='Mobile'"></kendo-maskedtextbox>-->
                    <a href="tel:{{selectedDriver.cell}}" [ngClass]="(macropointLocationProviderDevice=='Mobile'&&(selectedDriver.cell==''||selectedDriver.cell==null)) ? 'border border-danger' : ''">
                        {{selectedDriver.cellCountryAbbrev != null && selectedDriver.cellCountryAbbrev != '' ? (selectedDriver.cell | phone:selectedDriver.cellCountryAbbrev.trim()) : (selectedDriver.cell | phone:'US')}}
                    </a>
                </div>
            </div>
            <div class="row p-2">
                <div class="col-sm-3 font-weight-bold text-end">
                    Driver 2 Name
                </div>
                <div class="col-sm-7">
                    <select name="driver2ID" [(ngModel)]="tenderData.driverTwoId" class="form-select" (change)="driverChange($event, 2)" [disabled]="authService.authenticated">
                        <option value=""></option>
                        <option *ngFor="let driver of drivers" value="{{driver.contactID}}">{{driver.contactName}}</option>
                    </select>
                </div>
                <div class="col-sm-1" *ngIf="!authService.authenticated">
                    <button (click)="addContact('Driver2')" class="btn btn-sml btn-primary" title="Add Driver"><i class="fas fa-plus"></i></button>
                </div>
                <div class="col-sm-1" *ngIf="!authService.authenticated">
                    <button (click)="editContact('Driver2')" class="btn btn-sml btn-success" title="Edit Driver" *ngIf="tenderData.driverTwoId>0"><i class="fas fa-pencil-alt"></i></button>
                </div>
            </div>
            <div class="row p-2" *ngIf="isAddDriver2">
                <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                    <contact-quick-add [tableID]="tenderData.carrierId" [contactTitleID]="3" [contactType]="'Carrier'" [countryCode]="countryCode" (onRefreshContact)="refreshContacts($event, 'Driver2')"></contact-quick-add>
                </div>
            </div>
            <div class="row p-2" *ngIf="isEditDriver2">
                <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                    <contact-quick-edit [contactID]="tenderData.driverTwoId" (onRefreshContact)="refreshContacts($event, 'Driver2')"></contact-quick-edit>
                </div>
            </div>
            <div class="row p-2">
                <div class="col-sm-3 font-weight-bold text-end">
                    Driver 2 Cell
                </div>
                <div class="col-sm-9">
                    <!--<kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="selectedDriver2.cell" [disabled]="true"></kendo-maskedtextbox>-->
                    <a href="tel:{{selectedDriver2.cell}}" *ngIf="(selectedDriver2 | json) != '{}'">{{selectedDriver2.cellCountryAbbrev != null && selectedDriver2.cellCountryAbbrev != '' ? (selectedDriver2.cell | phone:selectedDriver2.cellCountryAbbrev.trim()) : (selectedDriver2.cell | phone:'US')}}</a>
                </div>
            </div>

            <p [ngClass]="{'text-danger': formValidator.truckNumber}">
                <label><strong>Truck Number:</strong></label>
                <input class="form-control input-sm" type="text" [(ngModel)]="tenderData.truckNumber" [ngModelOptions]="{standalone: true}" [disabled]="authService.authenticated" />
            </p>
            <p [ngClass]="{'text-danger': formValidator.trailerNumber}">
                <label><strong>Trailer Number:</strong></label>
                <input class="form-control input-sm" type="text" [(ngModel)]="tenderData.trailerNumber" [ngModelOptions]="{standalone: true}" [disabled]="authService.authenticated" />
            </p>
            <p [ngClass]="{'text-danger': formValidator.dispatcher||tenderData.dispatcherName==null||tenderData.dispatcherName==''}">
                <label><strong>Tender Accepted By:</strong></label>
                <input class="form-control input-sm" type="text" [(ngModel)]="tenderData.dispatcherName" [disabled]="authService.authenticated" [ngModelOptions]="{standalone: true}" />
            </p>

            <div class="row p-2" *ngIf="authService.authenticated">
                <div class="col-sm-3 font-weight-bold text-end">
                    Contact
                </div>
                <div class="col-sm-7">
                    <select name="contactID" [(ngModel)]="tenderData.carrierContactId" class="form-select" (change)="contactChange($event)" [disabled]="true">
                        <option value=""></option>
                        <option *ngFor="let contact of contacts" value="{{contact.contactID}}">{{contact.contactName}}</option>
                    </select>
                </div>
                <div class="col-sm-1" *ngIf="false">
                    <button (click)="addContact('Dispatcher')" class="btn btn-sml btn-primary" title="Add Contact"><i class="fas fa-plus"></i></button>
                </div>
                <div class="col-sm-1" *ngIf="false">
                    <button (click)="editContact('Dispatcher')" class="btn btn-sml btn-success" title="Edit Contact" *ngIf="tenderData.carrierContactId>0"><i class="fas fa-pencil-alt"></i></button>
                </div>
            </div>
            <div class="row p-2" *ngIf="isAddDispatcher">
                <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                    <contact-quick-add [tableID]="tenderData.carrierId" [contactTitleID]="2" [contactType]="'Carrier'" [countryCode]="countryCode" (onRefreshContact)="refreshContacts($event, 'Dispatcher')"></contact-quick-add>
                </div>
            </div>
            <div class="row p-2" *ngIf="isEditDispatcher">
                <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                    <contact-quick-edit [contactID]="tenderData.carrierContactId" (onRefreshContact)="refreshContacts($event, 'Dispatcher')"></contact-quick-edit>
                </div>
            </div>
            <div class="row p-2" *ngIf="authService.authenticated">
                <div class="col-sm-3 font-weight-bold text-end">
                    Phone
                </div>
                <div class="col-sm-9">
                    <kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="selectedContact.phone" [disabled]="true"></kendo-maskedtextbox>
                </div>
            </div>
            <div class="row p-2" *ngIf="authService.authenticated">
                <div class="col-sm-3 font-weight-bold text-end">
                    Email
                </div>
                <div class="col-sm-9">
                    <input class="form-control" [ngClass]="(selectedContact.email==null||selectedContact.email=='') ? 'border border-danger' : ''" type="text" [(ngModel)]="selectedContact.email" [disabled]="true" [required]="true" />
                    <!--<span *ngIf="selectedContact.email==null||selectedContact.email==''" class="font-weight-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>-->
                </div>
            </div>

            <p *ngIf="false&&authService.authenticated">
                <label><strong>Carrier Contact:</strong></label>
                <mat-select placeholder="Contact" [(value)]="tenderData.carrierContactId" style="margin: 5px;" disabled>
                    <mat-option></mat-option>
                    <mat-option *ngFor="let c of contacts" [value]="c.contactID">
                        {{c.fullName}}: {{c.phone}} - {{c.email}}
                    </mat-option>
                </mat-select>

                <label style="margin-top: 8px;">
                    <strong>Called &amp; Confirmed Pickup:</strong>
                    <input type="checkbox" [(ngModel)]="tenderData.verified" [ngModelOptions]="{standalone: true}" [disabled]="authService.authenticated" />
                </label>
            </p>


            <div style="margin: 5px;" *ngIf="!tenderData.accepted && !authService.authenticated">
                <button class="btn btn-success m-2" (click)="acceptOffer()" [disabled]="isLoading">Accept</button>
                <button class="btn btn-warning m-2" (click)="declineOffer()" [disabled]="isLoading">Decline</button>
            </div>
            <div style="margin: 5px;" *ngIf="tenderData.accepted && !authService.authenticated">
                <!--<button class="btn btn-primary" (click)="saveData()" [disabled]="isLoading||!isPickupStopDateValid">Update</button>-->
                <button class="btn btn-primary" (click)="saveData()" [disabled]="isLoading">Update</button>
            </div>
            <div style="margin: 5px;" *ngIf="false&&authService.authenticated">
                <button class="btn btn-primary" (click)="saveData()" [disabled]="isLoading||!isPickupStopDateValid">Save</button>
            </div>
            <div style="margin: 5px;" *ngIf="tenderData.orderNumber && !printVisible">
                <button class="btn btn-primary" (click)="print()">Print Preview</button>
            </div>
            <p *ngIf="false">
                {{saveMessage}}
            </p>
            <div *ngIf="validationWarningList.length>0">
                <ul class="alert-error alert-danger p-1">
                    <li *ngFor="let warning of validationWarningList">{{warning}}</li>
                </ul>
            </div>

            <div *ngIf="authService.authenticated">
                <h3>Macropoint</h3>
                <p>
                    <label style="display: block"><strong>Track Via:</strong></label>
                    <select name="macropointLocationProviderId" [(ngModel)]="macropointLocationProviderId" class="form-select" (change)="macropointLocationProviderChange($event)" [disabled]="true">
                        <option *ngFor="let provider of macropointLocationProviders" value="{{provider.macropointLocationProviderId}}">{{provider.device}}</option>
                    </select>
                    <!--<kendo-dropdownlist [data]="locationProviders"
                        [textField]="'device'"
                        [valueField]="'macropointLocationProviderId'"
                        [valuePrimitive]="true"
                        [(ngModel)]="providerId"
                        (valueChange)="providerChanged($event)"></kendo-dropdownlist>-->
                </p>
                <p>
                    <label style="display: block"><strong>Begin Tracking:</strong></label>
                    <kendo-datepicker style="width: 150px;" [disabled]="true" [(ngModel)]="beginTrackingDate"></kendo-datepicker>
                    <kendo-timepicker style="width: 150px;" [disabled]="true" [(ngModel)]="beginTrackingDate" [format]="'HH:mm'"></kendo-timepicker>
                </p>
                <p>
                    <label style="display: block"><strong>End Tracking:</strong></label>
                    <kendo-datepicker style="width: 150px;" [disabled]="true" [(ngModel)]="endTrackingDate"></kendo-datepicker>
                    <kendo-timepicker style="width: 150px;" [disabled]="true" [(ngModel)]="endTrackingDate" [format]="'HH:mm'"></kendo-timepicker>
                </p>
                <p>
                    <label style="display: block"><strong>Location Updates:</strong></label>
                    <!--<kendo-dropdownlist [data]="filteredTrackingOptions"
                                        [textField]="'locationUpdatesEvery'"
                                        [valueField]="'macropointTrackingOptionID'"
                                        [valuePrimitive]="true"
                                        [(ngModel)]="trackingId">
                    </kendo-dropdownlist>-->
                    <select name="trackingID" [(ngModel)]="macropointTrackInterval" class="form-select">
                        <option value=""></option>
                        <option *ngFor="let option of macropointTrackingOptions" value="{{option.macropointTrackingOptionID}}">{{option.locationProvider}}: {{option.locationUpdatesEvery}}</option>
                    </select>
                </p>
                <p>
                    <label style="display: block"><strong>Emails:</strong></label>
                    <textarea rows="5" cols="50" [(ngModel)]="macropointEmails"></textarea>
                </p>
                <p>
                    <button class="btn btn-primary" type="button" (click)="saveMacropoint()">Save Macropoint</button>
                </p>
                <p>
                    {{macropointData.returnMessage}}
                </p>
            </div>
        </div>
    </div>

    <div class="col-lg-8">
        <div class="row" *ngIf="tenderData.orderNumber">
            <div class="col-lg-12" *ngIf="tenderData.carrierRepName">
                <div class="row">
                    <div class="col-lg-3">
                        <label><strong>Carrier Rep: </strong></label> {{tenderData.carrierRepName}}
                    </div>
                    <div class="col-lg-3">
                        <label><strong>Phone: </strong></label> {{tenderData.carrierRepPhone}}
                    </div>
                    <div class="col-lg-3">
                        <label><strong>Cell: </strong></label> {{tenderData.carrierRepCell}}
                    </div>
                    <div class="col-lg-3">
                        <label><strong>Fax: </strong></label> {{tenderData.carrierRepFax}}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-3">
                <label><strong>Trailer Type:</strong></label> {{tenderData.trailerType}}
            </div>
        </div>
        <div *ngFor="let s of stopData.stops" class="row m-3 border-bottom">
            <div class="col-lg-4">
                <label><strong>STOP #:</strong></label> {{s.stopSequence}}  -  {{s.reportDescription}}
                <p>
                    <span *ngIf="s.customerName != null && s.customerName.length > 0">{{s.customerName}}<br /></span>
                    <span *ngIf="s.customerAddress != null && s.customerAddress.length > 0">{{s.customerAddress}}<br /></span>
                    <span *ngIf="s.customerAddress2 != null && s.customerAddress2.length > 0">{{s.customerAddress2}}<br /></span>
                    <span *ngIf="s.cityStateZip != null && s.cityStateZip.length > 0">{{s.cityStateZip}}</span>
                </p>
                <p>
                    Instructions: {{s.instructions}}
                </p>
            </div>
            <div class="col-lg-4">
                <label><strong>EARLIEST:</strong></label> {{s.earliestDate | date:'short'}}<br />
                <label><strong>LATEST:</strong></label> {{s.latestDate | date:'short'}}<br />
                <label><strong>WEIGHT:</strong></label> {{s.weight}} {{s.weightUnit}}<br />
                <label><strong>PIECES:</strong></label> {{s.pieces}} {{s.piecesUnit}}<br />
            </div>
            <div class="col-lg-4">
                <p>Order #: {{s.orderNumber}}-{{s.legNumber}}</p>
            </div>
        </div>
        <div class="row" *ngIf="tenderData.orderNumber">
            <div class="col-lg-5">
                <p>
                    <label><strong>Total Mileage:</strong></label> {{tenderData.miles}}
                </p>
                <div>
                    <label><strong>Pay Summary:</strong></label>
                    <div style="margin-left: 20px;">
                        <div style="display: block;">
                            <label style="width: 150px;"><strong>FLAT RATE:</strong></label>
                            {{tenderData.linehaulCharge | currency}}
                        </div>
                        <div style="display: block;">
                            <label style="width: 150px;"><strong>OTHER:</strong></label>
                            {{tenderData.otherCharge | currency}}
                        </div>
                        <div style="display: block;">
                            <label style="width: 150px;"><strong>FUEL:</strong></label>
                            {{tenderData.fuelCost | currency}}
                        </div>
                        <div style="display: block;">
                            <label style="width: 150px;"><strong>TOTAL:</strong></label>
                            {{tenderData.linehaulCharge + tenderData.otherCharge + tenderData.fuelCost | currency}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-7">
                <label><strong>Remarks:</strong></label> {{tenderData.comment}}
            </div>
        </div>
    </div>
</div>

<button class="btn btn-primary" (click)="hidePrint()" *ngIf="tenderData.orderNumber && printVisible">Hide Print</button>

<div class="row">
    <div class="col">
        <a class="btn btn-primary text-white m-1" target="_blank" href="{{docViewerFileUri}}" *ngIf="docViewerFileUri != ''">Download Rate Confirmation</a>
        <button class="btn btn-primary m-1" (click)="sendRateConfirmation()" *ngIf="authService.authenticated">Send Rate Confirmation</button>
    </div>
</div>
<!--<button type="button" class="btn btn-primary" (click)="viewFile()" *ngIf="tenderData.quoteOrderLineId">Toggle Rate Confirmation</button>-->
<div *ngIf="isDocViewer">
    <document-viewer [fileName]="docViewerFileName" [fileUri]="docViewerFileUri" [isWindow]="false"></document-viewer>
</div>
<!--<document-viewer [fileName]="docViewerFileName" [fileUri]="'docViewerFileUri'" [isWindow]="false"></document-viewer>-->

<div *ngIf="false && reportUrl != '' && encryptedOrder != ''" id="print-section" class="row" [ngClass]="{'reportGap': !printVisible}">
    <div class="col">
        <button *ngIf="authService.authenticated" class="btn btn-primary m-1" (click)="sendRateConfirmation()">Send Rate Confirmation</button>
        <button class="btn btn-primary m-1" (click)="viewer1!.refreshReport()"><i class="fas fa-redo"></i> Refresh Report</button>
        <p *ngIf="rateConMessage.length > 0">
            {{rateConMessage}}
        </p>
        <tr-viewer #viewer1 id="report-viewer" [containerStyle]="viewerContainerStyle"
                   [serviceUrl]="reportUrl"
                   [reportSource]="{
                        report: 'RateConfirmation.trdp',
                        parameters: { QuoteOrderLineId: tenderData.quoteOrderLineId ? tenderData.quoteOrderLineId : 0 }
                    }"
                   [viewMode]="'INTERACTIVE'"
                   [scaleMode]="'SPECIFIC'"
                   [persistSession]="false"
                   [scale]="1.0">
        </tr-viewer>
    </div>
</div>
